/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export interface AppMessageProps {
    readonly title?: string,
    readonly message: string,
    readonly onClose: () => void
}

export default function AppMessage({title, message, onClose}: AppMessageProps) {
    const { t } = useTranslation();
    return (
        <Dialog
            open={true}
            disableEscapeKeyDown
        >
            {title != undefined ? (
                <DialogTitle>{t(title)}</DialogTitle>
            )
                : null} 
            <DialogContent>
                <Typography>{t(message)}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    onClick={onClose}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
